/* Coingratulations: DOM product randomizer (ONE-SHOT per refresh)
   - Shuffles visible product cards exactly once on initial page load
   - Works on collection pages & homepage featured-collection sections
   - No MutationObserver, no post-load re-shuffles
*/

(function () {
  // Limit where it runs (edit if you want)
  // Example: only collections -> const PATH_OK = location.pathname.startsWith('/collections/');
  // Example: only homepage   -> const PATH_OK = location.pathname === '/';
  const PATH_OK = true;

  // Prefer explicit hook; fall back to common theme containers
  const GRID_SELECTORS = [
    '[data-product-grid]',
    '[id^="ProductGrid"] ul',
    '[id^="ProductGrid"] .grid',
    '.section-template__product-grid .grid',
    '.collection .product-grid',
    '.collection .grid',
    '.product-grid',
    '.collection-grid',
    '.grid--view-items'
  ];

  let hasShuffled = false; // hard-stop after first successful shuffle

  function pickGrid() {
    for (const sel of GRID_SELECTORS) {
      const el = document.querySelector(sel);
      if (el && el.children && el.children.length > 1) return el;
    }
    return null;
  }

  function shuffleChildren(container) {
    const items = Array.from(container.children);
    if (items.length < 2) return;

    // Fisher–Yates by re-appending nodes
    for (let i = items.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      container.appendChild(items[j]);
      items.splice(j, 1);
    }
  }

  function tryShuffleOnce() {
    if (hasShuffled || !PATH_OK) return false;
    const grid = pickGrid();
    if (!grid) return false;

    shuffleChildren(grid);
    hasShuffled = true; // lock it
    console.debug('[Randomize] Shuffled once this refresh.');
    return true;
  }

  // Attempt on DOM ready; if grid isn’t ready yet, retry a few times, then stop
  function run() {
    // Try immediately
    if (tryShuffleOnce()) return;

    // Retry up to N times for late-hydrated themes, then give up
    let tries = 0;
    const max = 12;
    const delay = 200;
    const id = setInterval(() => {
      if (tryShuffleOnce() || ++tries >= max) clearInterval(id);
    }, delay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
